import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";

export default function Cocktail() {
  const IMAGINI = [1, 2, 3, 4, 5].map(n => `/images/cocktail/${n}.png`);

  return (
    <section>
      <PageHero title="Rochii cocktail" subtitle="Croieli scurte sau midi, accent pe detalii." />
      <GalleryGrid items={IMAGINI} />
    </section>
  );
}
